(function IIFE() {
    'use strict';

    /////////////////////////////

    function GmailFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/gmail/:methodKey', {}, {
            list: {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'list',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('GmailFactory', GmailFactory);
})();
